import React from 'react';
import { Microphone, Stop } from 'phosphor-react';
import WaveformCanvas from './WaveformCanvas';

const AudioRecorder = ({
  isRecording,
  isSubmitting,
  recordingDuration,
  onStartRecording,
  onStopRecording,
  analyserNode,
  recordingError,
}) => {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="mt-1 flex flex-col items-center gap-5 max-md:mt-2 max-md:gap-4">
      <div className="flex flex-col items-center gap-5 max-md:gap-4">
        {!isRecording ? (
          <>
            <button
              type="button"
              className="flex flex-col items-center justify-center gap-2 w-[180px] h-[180px] max-md:w-[140px] max-md:h-[140px] rounded-full border-none p-0 text-xs font-semibold text-white cursor-pointer transition-all duration-300 font-[inherit] bg-gradient-to-br from-gray-500 to-gray-600 shadow-[0_4px_12px_rgba(107,114,128,0.3)] hover:shadow-[0_6px_16px_rgba(107,114,128,0.4)] disabled:opacity-60 disabled:cursor-not-allowed"
              onClick={onStartRecording}
              disabled={isSubmitting}
            >
              <Microphone size={32} weight="fill" />
              <span>{isSubmitting ? 'Submitting...' : 'Click to Record'}</span>
            </button>
            {recordingError && (
              <div
                role="alert"
                className="w-full max-w-[320px] rounded-xl border border-red-300/80 bg-red-50 px-4 py-3 text-sm leading-snug text-red-800 dark:border-red-500/40 dark:bg-red-950/35 dark:text-red-100 text-center"
              >
                {recordingError}
              </div>
            )}
          </>
        ) : (
          <div className="flex flex-col items-center gap-4">
            <button
              type="button"
              className="flex flex-col items-center justify-center gap-2 w-[180px] h-[180px] max-md:w-[140px] max-md:h-[140px] rounded-full border-none p-0 text-xs font-semibold text-white cursor-pointer transition-all duration-300 font-[inherit] bg-gradient-to-br from-red-500 to-red-600 shadow-[0_4px_12px_rgba(239,68,68,0.3)] hover:shadow-[0_6px_16px_rgba(239,68,68,0.4)]"
              onClick={onStopRecording}
            >
              <Stop size={32} weight="fill" />
              <span>Stop Recording</span>
            </button>
            <div className="flex items-center gap-3 max-md:gap-2.5 text-lg max-md:text-base font-semibold text-red-500">
              <span className="w-3 h-3 max-md:w-2.5 max-md:h-2.5 rounded-full bg-red-500 animate-[pronunciation-pulse_1.5s_ease-in-out_infinite]" />
              <span className="font-mono">{formatTime(recordingDuration)}</span>
            </div>
            <WaveformCanvas isRecording={isRecording} analyserNode={analyserNode} />
          </div>
        )}
      </div>
    </div>
  );
};

export default AudioRecorder;
